const SfAccountRow = (props) => {
  return (
    <div id={props.account_id} onClick={props.fold_unfold} className="sf_account_row sf_user_row foldable_label sf_user_hover">
      {props.children}
    </div>
  );
};

export default SfAccountRow;
